import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {Actions} from '../../../common/actions';
import {MANAGE_COLORS_FORM} from '../../../common/forms';
import {Button, Card, Form, Icon, Dimmer, Loader} from 'semantic-ui-react';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {cloneDeep, omitBy} from 'lodash';
import ColorData from './colorData';


class ManageColorsFormAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'typeOfSubmit': '',
      'addColorPermission': hasAccessPermission(props.permissions, resources.ManageColorsFormAdd, scopes.Create),
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ManageColorsFormAdd, scopes.Create)) {
      this.props.push(paths.AccessDenied);
    }
    this.clearForm();
  }

  onCancelClick() {
    this.props.push(paths.ManageColors);
  }

  clearForm() {
    this.props.reset();
  }

  render() {
    const {loading, submitting, handleSubmit} = this.props;
    const {addColorPermission} = this.state;
    const isDisabled = loading || submitting || !(addColorPermission);

    return (
      <Form
        className='vehicle-master-form'
        loading={submitting}
        onSubmit={handleSubmit(this.onSubmit.bind(this))}
        autoComplete='off'
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)} />
              <h2>Agregar Color</h2>
              <div className='title-bar-actions'>
                <Button secondary type='button' disabled={isDisabled}
                  onClick={this.clearForm.bind(this)}
                >
                  Cancelar
                </Button>
                <Button primary type='submit' disabled={isDisabled}
                  onClick={this.changeTypeOfSubmit.bind(this, 'SAVE')}
                >
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </Card>
        {this.renderLoader()}
        <ColorData {...this.props} addColor={addColorPermission}/>
      </Form>
    );
  }

  renderLoader() {
    const {loading, saving} = this.props;
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader inverted inline='centered' content='Cargando' />
        </Dimmer>
      );
    }
    if (saving) {
      return (
        <Dimmer active inverted>
          <Loader inverted inline='centered' content={this.getAction()} />
        </Dimmer>
      );
    }
    return null;
  }

  getAction() {
    const {typeOfSubmit} = this.state;
    switch (typeOfSubmit) {
      case 'SAVE':
        return 'Guardando';
      default:
        return '';
    }
  }

  changeTypeOfSubmit(type) {
    this.setState({
      'typeOfSubmit': type,
    });
  }

  onSubmit(formValues) {
    const {code} = this.props;
    const {typeOfSubmit} = this.state;
    const valuesChanged = this.getValuesChanged(formValues);
    if (!code) {
      this.props.createMasterColorsForm(valuesChanged);
      this.onCancelClick();
      return;
    }

    switch (typeOfSubmit) {
      case 'SAVE':
        this.props.createMasterColorsForm(code, typeOfSubmit, valuesChanged);
        this.onCancelClick();
        break;
      default:
        break;
    }
  }

  getValuesChanged(formValues) {
    const {initialValues} = this.props;
    const newValues = cloneDeep(formValues);
    delete newValues.colorList;
    const diff = omitBy(newValues, (v, k) => {
      return initialValues[k] === v;
    });
    return diff;
  }
}

export {ManageColorsFormAdd};

const form = reduxForm({
  'form': MANAGE_COLORS_FORM.name,
  'destroyOnUnmount': false,
})(ManageColorsFormAdd);

const mapStateToProps = (state, ownProps) => {
  const initialValues = state.form.manageColorsForm.initial || state.form.manageColorsForm.initialValues;
  return {
    'loading': state.manageColors.loading,
    'saving': state.form.manageColorsForm.saving,
    'goBack': ownProps.history.goBack,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'initialValues': initialValues,
  };
};

const {
  createMasterColorsForm, withRouter,
} = Actions;

const mapDispatchToProps = {
  createMasterColorsForm,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(form));
